import styled from 'styled-components';

export const DestructiveButtonContainer = styled.button`
  border: 2px solid ${({ theme }) => theme.colors.errorRed};
  background: ${({ theme }) => theme.colors.errorRed};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  span {
    color: ${({ theme }) => theme.colors.white} !important;
  }
  &:hover {
    background: ${({ theme }) => theme.colors.lightRed};
    color: ${({ theme }) => theme.colors.errorRed};
    border: 2px solid ${({ theme }) => theme.colors.errorRed};
  }
  span:active {
    color: ${({ theme }) => theme.colors.errorRed};
  }
  span:hover {
    color: ${({ theme }) => theme.colors.errorRed};
  }
`;
